<div class="help-content">
  <h1>Help</h1>
  <br/>
  <br/>
  <div>
    <p>1. You can contiue to submit the assessment after one another or go back to the main menu to select an assessment</p>
    <p>2. You can re-visit the link from the sms anytime to submit the forms for the day</p>
  </div>
</div>